export default "__VITE_ASSET__Aal1_Ns7__"